import AyrtonSennaImg from '../dados/imagens/AyrtonSenna.jpg';
import LeliaGonzalezImg from '../dados/imagens/leliagonzalez.jpg';
import HeitorVillaLobosImg from '../dados/imagens/heitorvila.png';
import SalaoperacoesImg from '../dados/imagens/Salaoperacoes.jpg';
import LojaModeloImg from '../dados/imagens/Lojamodelo.jpg';
import ClarisseImg from '../dados/imagens/Claricelispector.jpg';
import DandaraImg from '../dados/imagens/Dandara.jpg';
import CaciqueImg from '../dados/imagens/cacique.jpg';
import OswaldoImg from '../dados/imagens/oswaldo.jpg';
import PaulofreireImg from '../dados/imagens/Paulofreire.png';
import CarloschagasImg from '../dados/imagens/Carloschagas.png';
import TarsiliaImg from '../dados/imagens/Tarsiliapng.png';
import SantosdumontImg from '../dados/imagens/santosdumont.jpeg';
import ViniciusdeMoraesImg from '../dados/imagens/vinicius.jpg';
import TomjobimImg from '../dados/imagens/tomjobim.jpeg';


export const PersonasTerreo = [

    {
        id_Persona: 1,
        imagem: AyrtonSennaImg,
        name: "Ayrton Senna",
        desc: "Sala de Aula",
        quantidade: "Quantidade de Alunos(as): 12",
        cafe: "Café da Manhã: 10:30",
        almoco: "Almoço: 12:30",
        cafetarde: "Café da Tarde: 15:30",
        Resumopersona: "Ayrton Senna (1960-1994) foi um dos maiores pilotos de Fórmula 1, vencedor de três campeonatos mundiais e reconhecido por sua habilidade e velocidade, especialmente em condições adversas. Sua morte trágica em 1994 o transformou em um símbolo de perseverança e superação no esporte.",
        Link: "/Senna"
    },
    {
        id_Persona: 2,
        imagem: LeliaGonzalezImg,
        name: "Lélia Gonzales",
        desc: "Sala Comercial",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "Lélia Gonzalez (1935-1994) foi uma intelectual, filósofa, antropóloga e ativista brasileira, reconhecida por sua atuação no movimento negro e feminista. Com raízes afro-indígenas, foi pioneira na luta contra o racismo estrutural e na valorização da cultura afro-brasileira.",
        Link: "/Lelia"
    },
    {
        id_Persona: 3,
        imagem: HeitorVillaLobosImg,
        name: "Heitor Villa-Lobos",
        desc: "Auditório",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "Heitor Villa-Lobos (1887-1959) é reconhecido como o maior compositor brasileiro de música clássica, conhecido por integrar a tradição europeia com elementos da música popular e folclórica do Brasil.",
        Link: "/Heitor"
    }
]

export const Personas1andar = [

    {
        id_Persona: 4,
        imagem: SalaoperacoesImg,
        name: "Sala de operações",
        desc: "",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "A Sala de Operações da UCA é um espaço colaborativo onde uma equipe multidisciplinar cria conteúdos educativos inovadores, transformando ideias em conhecimento com foco no futuro.",
        Link: "/SalaOperacoes"
    },
    {
        id_Persona: 5,
        imagem: LojaModeloImg,
        name: "Loja Modelo",
        desc: "",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "A Loja Modelo é um espaço de treinamento prático que simula um ambiente real de vendas, com produtos e um caixa. Nele, os participantes aprendem atendimento ao cliente, gestão de estoque e operações de caixa.",
        Link: "/LojaModelo"

    },
]

export const Personas2andar = [

    {
        id_Persona: 6,
        imagem: ClarisseImg,
        name: "Clarice Lispector",
        desc: "Sala de Aula (Antiga Rui Barbosa)",
        quantidade: "Quantidade de Alunos(as): 8",
        cafe: "Café da Manhã: 10:15",
        almoco: "Almoço: 12:15",
        cafetarde: "Café da Tarde: 15:15",
        Resumopersona: "Clarice Lispector (1920-1977) foi uma renomada escritora e jornalista brasileira, cuja prosa poética e introspectiva explorou questões existenciais e psicológicas. Ela desafiou as normas literárias, inspirando leitores e escritores pelo mundo com seu estilo inovador e profundo.",
        Link: "/Clarice"

    },
    {
        id_Persona: 7,
        imagem: DandaraImg,
        name: "Dandara dos Palmares",
        desc: "Sala de Aula (Antiga Mário Quintana)",
        quantidade: "Quantidade de Alunos(as): 9",
        cafe: "Café da Manhã: 09:45",
        almoco: "Almoço: 11:45",
        cafetarde: "Café da Tarde: 14:45",
        Resumopersona: "Dandara dos Palmares (século XVII) foi uma líder quilombola ao lado de Zumbi dos Palmares, lutando contra a escravidão. Sua história é um símbolo de resistência negra e feminina, inspirando até hoje movimentos sociais pela liberdade.",
        Link: "/Dandara"
    },
    {
        id_Persona: 8,
        imagem: CaciqueImg,
        name: "Cacique Raoni Metuktire",
        desc: "Sala de Aula (Antiga Monteiro Lobato)",
        quantidade: "Quantidade de Alunos(as): 10",
        cafe: "Café da Manhã: 09:30",
        almoco: "Almoço: 11:30",
        cafetarde: "Café da Tarde: 14:30",
        Resumopersona: "Cacique Raoni Metuktire, líder indígena Kayapó, é reconhecido mundialmente pela defesa dos direitos dos povos indígenas e pela preservação da Amazônia.",
        Link: "/Cacique"

    },
    /*{
        id_Persona: 9,
        imagem: OswaldoImg,
        name: "Oswaldo Cruz",
        desc: "Estúdio",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "Oswaldo Cruz (1872-1917) foi um médico e sanitarista brasileiro que revolucionou a saúde pública no Brasil, liderando campanhas contra doenças como febre-amarela, varíola e peste bubônica. Seu trabalho foi crucial para o fortalecimento do sistema de saúde pública."
    },
    {
        id_Persona: 10,
        imagem: PaulofreireImg,
        name: "Paulo Freire",
        desc: "Sala inutilizada",
        quantidade: "",
        cafe: "",
        almoco: "",
        cafetarde: "",
        Resumopersona: "Paulo Freire (1921-1997) foi um educador e filósofo brasileiro, reconhecido mundialmente por sua pedagogia libertadora. Em sua obra Pedagogia do Oprimido, ele propôs uma metodologia que valoriza o diálogo e a participação ativa dos alunos."
    },*/
    {
        id_Persona: 11,
        imagem: CarloschagasImg,
        name: "Carlos Chagas",
        desc: "Sala de Aula",
        quantidade: "Quantidade de Alunos(as): 14",
        cafe: "Café da Manhã: 10:30",
        almoco: "Almoço: 12:30",
        cafetarde: "Café da Tarde: 15:30",
        Resumopersona: "Carlos Chagas (1879-1934) foi um médico brasileiro que descobriu a Doença de Chagas e identificou seu ciclo completo. Além disso, contribuiu para a saúde pública e o controle de doenças tropicais no Brasil.",
        Link: "/CarlosChagas"
    },
]

export const Personas3andar = [

    {
        id_Persona: 12,
        imagem: TarsiliaImg,
        name: "Tarsila do Amaral",
        desc: "Sala de Aula (Antiga Oscar Niemeyer)",
        quantidade: "Quantidade de Alunos(as): 10",
        cafe: "Café da Manhã: 09:45",
        almoco: "Almoço: 11:45",
        cafetarde: "Café da Tarde: 14:45",
        Resumopersona: "Tarsila do Amaral (1886-1973) foi uma importante artista modernista brasileira de 1922. Suas obras, como Abaporu, incorporaram elementos da cultura popular e indígena.",
        Link: "/Tarsila"

    },
    {
        id_Persona: 13,
        imagem: SantosdumontImg,
        name: "Santos Dumont",
        desc: "Sala de Aula",
        quantidade: "Quantidade de Alunos(as): 10",
        cafe: "Café da Manhã: 10:00",
        almoco: "Almoço: 12:00",
        cafetarde: "Café da Tarde: 15:00",
        Resumopersona: "Alberto Santos Dumont (1873-1932) foi um pioneiro da aviação brasileiro, conhecido pelo voo histórico do 14-bis em 1906. Sua personalidade carismática e suas conquistas marcaram a história, apesar de sua morte trágica em 1932.",
        Link: "/SantosDumont"

    },
    {
        id_Persona: 14,
        imagem: ViniciusdeMoraesImg,
        name: "Vinícius de Moraes",
        desc: "Sala de Aula",
        quantidade: "Quantidade de Alunos(as): 10",
        cafe: "Café da Manhã: 09:30",
        almoco: "Almoço: 11:30",
        cafetarde: "Café da Tarde: 14:30",
        Resumopersona: "Vinícius de Moraes (1913-1980) foi um poeta, diplomata e compositor brasileiro, central na Bossa Nova, especialmente em parceria com Tom Jobim. Sua poesia sobre amor e amizade deixaram um legado duradouro.",
        Link: "/ViniciusDeMoraes"

    },
    {
        id_Persona: 15,
        imagem: TomjobimImg,
        name: "Tom Jobim",
        desc: "Sala de Aula",
        quantidade: "Quantidade de Alunos(as): 12",
        cafe: "Café da Manhã: 10:15",
        almoco: "Almoço: 12:15",
        cafetarde: "Café da Tarde: 15:15",
        Resumopersona: "Tom Jobim (1927-1994) foi um dos fundadores da Bossa Nova, criando uma sonoridade única ao misturar jazz e samba. Famoso por clássicos como Garota de Ipanema, seu legado musical é celebrado mundialmente.",
        Link: "/TomJobim"

    }]

export const RodapeInformacoes = [

    {
        PortalUca: "https://portaluca.alterdata.com.br/login/index.php",
        Ucaplus: "https://ucaplus.alterdata.com.br/",
        Ucacursos: "https://universidade-corporativa-alterdata.eadbox.com/",
        AjudaERP: "https://www.instagram.com/ajuda.alterdataerp/?igshid=NGVhN2U2NjQ0Yg%3D%3D",
        AjudaPack: "https://www.instagram.com/ajuda.alterdatacontabil/?igshid=OGQ5ZDc2ODk2ZA%3D%3D",
        Ucacursos: "https://www.instagram.com/uca.cursos/?igshid=ZGUzMzM3NWJiOQ%3D%3D",
        Ajudaempresarial: "https://t.me/ajudaalterdatavarejo",
        AjudapackTel: "https://t.me/+i03gaYrLBvUxYTYx",
        Ajudapro: "https://t.me/ajudaalterdataprosoft",
        Ucacursostelegr: "https://t.me/ucacursos"

    }
]
